import { SeverityBadge } from "@/components/StatusBadge";
import { Sparkles } from "lucide-react";

export default function AiAnalysisView({ analysis }) {
  if (!analysis) return null;
  const achados = analysis.achados || [];
  const recs = analysis.recomendacoes || [];
  return (
    <div className="mt-4 bg-secondary/60 border-l-4 border-ai rounded-r-lg p-5 space-y-4" data-testid="ai-analysis-view">
      <div className="flex items-center gap-2 text-ai">
        <Sparkles className="w-4 h-4" />
        <span className="text-xs font-bold uppercase tracking-[0.15em]">Análise da IA</span>
      </div>
      {analysis.raw && !analysis.resumo && (
        <p className="text-sm leading-relaxed whitespace-pre-wrap">{analysis.raw}</p>
      )}
      {analysis.resumo && <p className="text-sm leading-relaxed">{analysis.resumo}</p>}
      {analysis.impressao && (
        <p className="text-sm"><span className="font-semibold">Impressão: </span>{analysis.impressao}</p>
      )}
      {achados.length > 0 && (
        <div className="space-y-2">
          {achados.map((a, i) => (
            <div key={i} className="flex items-start justify-between gap-3 bg-card rounded-md p-3 border border-border">
              <div>
                <p className="text-sm font-medium">{a.marcador || a.regiao}</p>
                <p className="text-sm text-muted-foreground">{a.interpretacao || a.descricao}</p>
              </div>
              {a.gravidade && <SeverityBadge severity={a.gravidade} />}
            </div>
          ))}
        </div>
      )}
      {recs.length > 0 && (
        <div>
          <p className="text-xs font-bold uppercase tracking-wider text-muted-foreground mb-1">Recomendações</p>
          <ul className="list-disc list-inside text-sm space-y-1">
            {recs.map((r, i) => <li key={i}>{r}</li>)}
          </ul>
        </div>
      )}
      {analysis.disclaimer && (
        <p className="text-xs text-muted-foreground italic border-t border-border pt-2">{analysis.disclaimer}</p>
      )}
    </div>
  );
}
